import { JsonReader } from '../../imports/jsonReader';

const characterTagLoader = () => {
  const jsonFileContents = new JsonReader('./Assets/media/data/dataFile.json');
  const characterTagList = document.querySelector('.js-charactertag-list');
  const characterTagItem = document.querySelector('.js-charactertag-item') as HTMLButtonElement;
  const searchItem = document.querySelector('.js-character-item');

  function showSearchResult(character:string) {
    const searchList = document.querySelector('.js-character-result');
    const detailUrl = 'detail.html';

    if (searchList && searchItem) {
      jsonFileContents.getByCharacter(character)
      .then( jsonData => {
        searchList.innerHTML = '';

        jsonData.forEach( (element:any) => {
          let itemLink = searchItem.querySelector('a');

          if (itemLink) {
            let hrefUrl = detailUrl + '?id=' + element.id + '&categ=' + element.familyname;
            itemLink.href = hrefUrl;
            if (element.displayname != '' && element.displayname != null) {
              itemLink.innerHTML = element.displayname;
            } else if (element.character_displayname != '' && element.character_displayname != null) {
              itemLink.innerHTML = element.character_displayname;
            } else {
              itemLink.innerHTML = element.name;
            }
          }

          let temp = searchItem.cloneNode(true);
          searchList.appendChild(temp);
        });

        searchList.scrollTop = 0;

        if (window.innerWidth <= 767) {
          //@ts-ignore
          new SimpleBar(searchList, { autoHide: false } );
        }
      })
      .catch( error => {
        console.error('Error:', error);
      })
    ;
    }
  }

  if (jsonFileContents) {
    showSearchResult('');

    if (characterTagItem && characterTagList) {
      jsonFileContents.getContents('character')
        .then( jsonData => {
          if (jsonData.length > 0) {
            characterTagList.innerHTML = '';

            jsonData.forEach( (element:any, key:any) => {
              characterTagItem.innerHTML = element.character + '行';
              characterTagItem.value = element.character;
              
              let temp = characterTagItem.cloneNode(true) as HTMLElement;
              if (key == 0) {
                temp.classList.add('active');
              }
              temp.addEventListener('click', function () {
                let items = document.querySelectorAll('.js-charactertag-item');
                
                if (items.length > 0) {
                  items.forEach(element2 => {
                    element2.classList.remove('active');
                  });
                  temp.classList.add('active');
                }
                
                showSearchResult(element.character);
              });
              characterTagList.append(temp);
            });
          }
        })
        .catch( error => {
          console.error('Error:', error);
        })
      ;
    }
  }
};
  
export default characterTagLoader;